import { useCallback, useEffect, useState } from 'react';

// The images uploaded in Web Admin (backend site_images.py), for the Images
// panel and the home page's photo pickers (PageImages.jsx).
export default function useSiteImages(session, onExpired) {
  const [images, setImages] = useState(null);
  const [error, setError] = useState('');

  const reload = useCallback(() => {
    fetch('/api/site-admin/images', { headers: { Authorization: `Bearer ${session.session_token}` } })
      .then(async res => {
        if (res.status === 401) { onExpired(); return; }
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Could not load the images');
        setImages(data.images);
        setError('');
      })
      .catch(e => setError(e.message));
  }, [session, onExpired]);

  useEffect(() => { reload(); }, [reload]);

  return { images, error, reload };
}
